const registeredEventsStyles = (theme) => {
  return {
    root: {
      width: '100%',
    },
    button: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      color: '#fff', //D1373F
      backgroundColor: '#008000',
      borderColor: '#008000',
      minWidth: theme.spacing(14),
      borderWidth: theme.spacing(0.2),
      '&:hover': {
        backgroundColor: '#008000',
        borderColor: '#00acc1',
      },
    },
  };
};

export default registeredEventsStyles;
